__turbopack_context__.v({
  "charCount": "yEgEiq_charCount",
  "editor": "yEgEiq_editor",
  "editorError": "yEgEiq_editorError",
  "errorMessage": "yEgEiq_errorMessage",
  "genButton": "yEgEiq_genButton",
  "header": "yEgEiq_header",
  "label": "yEgEiq_label",
  "loader": "yEgEiq_loader",
  "loading": "yEgEiq_loading",
  "prixClipFix": "yEgEiq_prixClipFix",
  "pulse": "yEgEiq_pulse",
  "root": "yEgEiq_root",
  "rotate": "yEgEiq_rotate",
});
